import type {
  FontSystemIssue,
  LegacyGoogleFontImportIssue,
  MissingGlobalCssIssue,
} from "./types"
import { GLOBAL_CSS_PATH } from "./constants"

const missingGlobalCss = (): MissingGlobalCssIssue => ({
  _tag: "MissingGlobalCss",
  path: GLOBAL_CSS_PATH,
})

const legacyGoogleFontImport = (): LegacyGoogleFontImportIssue => ({
  _tag: "LegacyGoogleFontImport",
  path: GLOBAL_CSS_PATH,
})

export const validateLegacyFontImport = (
  input: string | null | undefined,
): readonly FontSystemIssue[] => {
  if (input == null) {
    return [missingGlobalCss()]
  }

  if (/fonts\.googleapis\.com/.test(input)) {
    return [legacyGoogleFontImport()]
  }

  return []
}
